import React from 'react';
import { Gift } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid, Steps } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function PerkVaultPage() {
  const module = getModule('perkvault')!;
  return (
    <ModulePageLayout module={module} Icon={Gift}>
      <Section title="Your Loyalty Points, Finally Worth Something">
        <p className="text-gray-700 leading-relaxed">
          PerkVault turns scattered loyalty points — merchant cash back, bank cash back, airline miles, retail
          loyalty points, store credits, even crypto rewards — into a unified financial asset you can pledge
          as collateral for real loans.
        </p>
      </Section>

      <Section title="From Points to Cash">
        <Steps
          items={[
            'Connect your reward sources; each is standardized to a real-time market value through the valuation engine.',
            'Pledge points as collateral — used either as a Discount (lowers your interest rate) or a Reduction (lowers principal).',
            'Borrow a fast microloan sized to your collateral value and LTV ratio.',
            'If you default, pledged points are liquidated; if it was a mistake, an appeal can reverse the liquidation.',
          ]}
        />
      </Section>

      <Section title="What's Tracked">
        <FeatureGrid
          items={[
            { title: 'Live Valuation', body: 'Real-time pricing of reward points based on live offers, bids, and price trends.' },
            { title: 'Collateral Agreements', body: 'Each pledge tracks status — Active, Released, or Forfeited — and links to its loan and capital pool.' },
            { title: 'Liquidation Reasons', body: 'Default, fraud, merchant exit, or market drop — every liquidation is reasoned and logged.' },
            { title: 'Digital Currency Assets', body: 'Some rewards are backed by or convertible to digital currencies, expanding what you can do with them.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
